import { Spinner } from "../../spinner";

export function DataTableLoading() {
	return (
		<div className="z-20 absolute inset-0 flex-col flex-center gap-8 pointer-events-none">
			<Spinner />
			<p className="text-sm">Daten werden geladen</p>
		</div>
	);
}
